import { render, staticRenderFns } from "./GenericTableComponent.vue?vue&type=template&id=4f722058&scoped=true&"
import script from "./GenericTableComponent.vue?vue&type=script&lang=js&"
export * from "./GenericTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./GenericTableComponent.vue?vue&type=style&index=0&id=4f722058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f722058",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
